let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2h4rq")).then(() => parcelRequire('3EuZR'));